module.exports = __webpack_public_path__ + "dist/img/Activity-Marketing.ed66e0c2.jpg";